module.exports = __webpack_public_path__ + "static/media/cases_logos_institucionais_02.e474a0a7.jpg";